export default __webpack_public_path__ + "static/media/LES GUIDES-DE RANDONNÉE.70ac8603.svg";